module.exports = "/_next/static/images/ef0fa4acbddbeb458bf726870f021ae2-cartao-proximo-ao-olho-md@2x.jpg";